import { createFileRoute, redirect } from '@tanstack/react-router'

// Phase 24: legacy catch-all. Any /connectors/* path (including /connectors
// itself, /connectors/foo, /connectors/some-old-id/sub-path, etc.) redirects
// to /settings. The `from=connectors-legacy` flag is consumed by
// SettingsProfile to fire a one-shot notification.
// We intentionally do NOT emit side-effects from beforeLoad — the notifier
// mounts inside the app tree; hard-load of a legacy URL would race the root
// render, so the settings surface handles it after mount.
export const Route = createFileRoute('/_authenticated/connectors/$')({
  beforeLoad: () => {
    throw redirect({
      to: '/settings',
      search: { from: 'connectors-legacy' },
    })
  },
})
